import { render, staticRenderFns } from "./averagepersons.vue?vue&type=template&id=3441cbb1&scoped=true&"
import script from "./averagepersons.vue?vue&type=script&lang=js&"
export * from "./averagepersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441cbb1",
  null
  
)

export default component.exports